import React, { useState, useEffect, Suspense, lazy } from "react";
import { Loader } from "./Loader";
import { NavDropPanel } from "./NavDropPanel";
import { usePanelView } from "../lib/panelView";
import SettingsAdmin from "./admin/SettingsAdmin";
import AdminHub from "./admin/AdminHub";
import NotificationsAdmin from "./admin/NotificationsAdmin";
import StatsSwitchboard from "../pages/StatsSwitchboard";
import Leagues from "../pages/Leagues";
import StorageCentre from "../pages/StorageCentre";

const Owner = lazy(() => import("../pages/Owner"));

export const OWNER_TOOL_VIEWS = {
    owner: ["Owner", Owner],
    settings: ["Settings", SettingsAdmin],
    stats: ["Switchboard", StatsSwitchboard],
    storage: ["Storage Centre", StorageCentre],
    leagues: ["All Leagues", Leagues],
    hub: ["Admin Hub & Hiring", AdminHub],
    notifications: ["Notifications", NotificationsAdmin],
};

export const openOwnerTool = (key) => window.dispatchEvent(new CustomEvent("open-owner-tool", { detail: key }));

// Owner Tools slide out from the nav bar; switch tools from the pills, no "back" step.
export function OwnerToolModal() {
    const [key, setKey] = useState(null);
    const cur = React.useRef(null);
    cur.current = key;
    useEffect(() => {
        const on = (e) => setKey(cur.current === e.detail ? null : e.detail);
        window.addEventListener("open-owner-tool", on);
        return () => window.removeEventListener("open-owner-tool", on);
    }, []);
    const view = key && OWNER_TOOL_VIEWS[key];
    usePanelView(view ? `/owner-tools/${key}` : null);
    useEffect(() => { window.dispatchEvent(new CustomEvent("owner-tool-state", { detail: view ? key : null })); }, [view, key]);
    const Comp = view?.[1];
    return (
        <NavDropPanel open={!!view} onClose={() => setKey(null)} kicker="Owner Tools" title={view?.[0] || ""} wide testid="owner-tool-panel" active={key}>
            {Comp && (
                <div className="rounded-2xl border border-white/10 shadow-2xl overflow-hidden" style={{ background: "#0B0D14" }} data-testid={`owner-tool-view-${key}`}>
                    <Suspense fallback={<Loader />}><Comp /></Suspense>
                </div>
            )}
        </NavDropPanel>
    );
}
